<template>
  <div class="agent-container">
    <div v-if="loading" class="loading">正在加载聊天窗口...</div>
    <div v-if="error" class="error">{{ error }}</div>
    <div
      v-show="!loading && !error"
      id="iframe-wrapper"
      class="iframe-wrapper"
    ></div>
  </div>
</template>

<script>
import { decodeUserId, compressAndEncode } from "@/utils/codec";

// Dify 基础配置
const BASE_URL = "https://dify.smsmart.net/chatbot/wdFIyzbwnLEsGVry";

export default {
  name: "Agent",
  data() {
    return {
      loading: true,
      error: null,
      userId: null,
    };
  },
  async mounted() {
    await this.initDifyChat();
  },
  methods: {
    async initDifyChat() {
      try {
        const { userId: encodedUserId } = this.$route.params;

        if (!encodedUserId) {
          this.error = "缺少用户标识参数";
          this.loading = false;
          return;
        }

        const userId = decodeUserId(encodedUserId);

        if (!userId) {
          this.error = "无效的用户标识";
          this.loading = false;
          return;
        }

        this.userId = userId;
        console.log("解码后的用户ID:", userId);

        await this.loadDifyIframe();

        this.loading = false;
      } catch (error) {
        console.error("初始化 Dify 聊天窗口失败:", error);
        this.error =
          "加载失败，请检查浏览器控制台 (F12)。您的浏览器可能不支持 CompressionStream API。";
        this.loading = false;
      }
    },

    async loadDifyIframe() {
      const timestamp = Date.now();
      const encodedUserId = await compressAndEncode(this.userId);
      // sys.user_id 每次使用时间戳保持唯一，确保服务端创建新对话
      const encodedSession = await compressAndEncode(
        this.userId + ":" + timestamp
      );

      // 生成唯一的随机 conversation_id，让 Dify JS 使用 URL 参数
      // 而不是 localStorage 中缓存的旧 conversation_id
      const randomConvId =
        "conv_" + Date.now().toString(36) + "_" + Math.random().toString(36).slice(2, 10);

      console.log("用户ID(稳定):", encodedUserId);
      console.log("会话ID(唯一):", encodedSession);
      console.log("对话ID(随机):", randomConvId);

      // 传入随机 conversation_id，覆盖 iframe 内部 localStorage 缓存
      const finalUrl =
        `${BASE_URL}` +
        `?app_user_id=${encodedUserId}` +
        `&conversation_id=${randomConvId}` +
        `&sys.user_id=${encodedSession}` +
        `&_t=${timestamp}`;

      console.log("最终生成的 URL:", finalUrl);

      const iframeWrapper = document.getElementById("iframe-wrapper");
      if (!iframeWrapper) {
        this.error = "找不到 iframe 容器";
        return;
      }

      // 清空并重建 iframe
      iframeWrapper.innerHTML = "";

      const iframe = document.createElement("iframe");
      iframe.id = "dify-chat-frame";
      iframe.allow = "microphone";
      iframe.frameBorder = "0";
      iframe.style.width = "100%";
      iframe.style.height = "100%";
      iframe.style.border = "none";
      iframe.src = "";

      // 先添加到 DOM，再设置 src
      iframeWrapper.appendChild(iframe);

      iframe.src = finalUrl;
    },
  },
};
</script>

<style scoped>
.agent-container {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  position: relative;
}

.loading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-family: sans-serif;
  color: #666;
  font-size: 14px;
}

.error {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-family: sans-serif;
  color: #ff4d4f;
  font-size: 14px;
  text-align: center;
  padding: 0 20px;
}

.iframe-wrapper {
  width: 100%;
  height: calc(100vh + 50px);
  overflow: hidden;
}

iframe {
  display: block;
  width: 100%;
  height: 100%;
  border: none;
}
</style>
